export default {
  getUserName({ commit }) {
    const username = parseInt(Math.random(1) * 100) + 'new'
    commit('SET_USERNAME', username)
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/index.js